/**
 * Maps user roles to their corresponding role models
 * @param {string} userRole - The user's role
 * @returns {string} The corresponding role model name
 */
export const getRoleModelForUser = (userRole) => {
  const roleModelMapping = {
    'issuer': 'IssuerRole',
    'custodian': 'CustodianRole',
    'investor': 'InvestorRole',
    'facility_agent': 'FacilityAgentRole',
    'primary_subscriber': 'PrimarySubscriberRole',
    'super_admin': 'SuperAdminRole',
    'exchange': 'SuperAdminRole', // Exchange uses SuperAdminRole for now
    'arranger': 'SuperAdminRole'  // Arranger uses SuperAdminRole for now
  };

  return roleModelMapping[userRole] || 'SuperAdminRole';
};

/**
 * Maps role models to their corresponding API services
 * @param {string} roleModel - The role model name
 * @returns {string} The corresponding API service name
 */
export const getAPIServiceForRoleModel = (roleModel) => {
  const apiServiceMapping = {
    'IssuerRole': 'issuerRolesAPI',
    'CustodianRole': 'custodianRolesAPI',
    'InvestorRole': 'investorRolesAPI',
    'FacilityAgentRole': 'facilityAgentRolesAPI',
    'SuperAdminRole': 'superAdminRolesAPI'
  };

  return apiServiceMapping[roleModel] || 'superAdminRolesAPI';
};
